import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import "./App.css";
import "./HomePage.css";
import AppFooter from "./AppFooter";
import { setToken } from "./authStorage";

const API_BASE = process.env.REACT_APP_API_BASE || "/api";

/* Small line-drawn icon set, purpose-built for this page rather than
   pulled from a generic icon font. Each one is a single idea, not a badge. */

const IconShield = (props) => (
  <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.6" {...props}>
    <path d="M12 3l7 3v5c0 4.5-3 7.7-7 9-4-1.3-7-4.5-7-9V6l7-3z" strokeLinejoin="round" />
    <path d="M9 12l2 2 4-4" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
);

const IconScan = (props) => (
  <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.6" {...props}>
    <path d="M4 8V5a1 1 0 0 1 1-1h3M20 8V5a1 1 0 0 0-1-1h-3M4 16v3a1 1 0 0 0 1 1h3M20 16v3a1 1 0 0 1-1 1h-3" strokeLinecap="round" />
    <path d="M6 12h12" strokeLinecap="round" />
  </svg>
);

const IconClock = (props) => (
  <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.6" {...props}>
    <circle cx="12" cy="12" r="8.5" />
    <path d="M12 7.5V12l3 2" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
);

const IconUpload = (props) => (
  <svg width="26" height="26" viewBox="0 0 28 28" fill="none" stroke="currentColor" strokeWidth="1.6" {...props}>
    <path d="M14 18V6M9.5 10.5 14 6l4.5 4.5" strokeLinecap="round" strokeLinejoin="round" />
    <path d="M6 18v3a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2v-3" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
);

const IconBank = (props) => (
  <svg width="26" height="26" viewBox="0 0 28 28" fill="none" stroke="currentColor" strokeWidth="1.6" {...props}>
    <path d="M4 11l10-6 10 6" strokeLinecap="round" strokeLinejoin="round" />
    <path d="M5.5 11.5v8M11 11.5v8M17 11.5v8M22.5 11.5v8" strokeLinecap="round" />
    <path d="M4 22.5h20" strokeLinecap="round" />
  </svg>
);

const IconGrid = (props) => (
  <svg width="26" height="26" viewBox="0 0 28 28" fill="none" stroke="currentColor" strokeWidth="1.6" {...props}>
    <rect x="5" y="5" width="18" height="18" rx="1" />
    <path d="M5 11h18M5 17h18M11 5v18M17 5v18" />
  </svg>
);

const IconEdit = (props) => (
  <svg width="26" height="26" viewBox="0 0 28 28" fill="none" stroke="currentColor" strokeWidth="1.6" {...props}>
    <path d="M18 5.5 22.5 10 11 21.5 5.5 22.5l1-5.5L18 5.5Z" strokeLinejoin="round" />
  </svg>
);

const IconFilter = (props) => (
  <svg width="26" height="26" viewBox="0 0 28 28" fill="none" stroke="currentColor" strokeWidth="1.6" {...props}>
    <path d="M4.5 6h19L16 14.5v6.5l-4 2v-8.5L4.5 6Z" strokeLinejoin="round" />
  </svg>
);

const IconBolt = (props) => (
  <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.6" {...props}>
    <path d="M13 3 5 14h6l-1 7 9-12h-6l1-6Z" strokeLinejoin="round" />
  </svg>
);

const IconLock = (props) => (
  <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.6" {...props}>
    <rect x="5" y="11" width="14" height="9" rx="1.4" />
    <path d="M8 11V8a4 4 0 0 1 8 0v3" />
  </svg>
);

const IconStack = (props) => (
  <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.6" {...props}>
    <path d="M12 4 3 8.5 12 13l9-4.5L12 4Z" strokeLinejoin="round" />
    <path d="M3 13l9 4.5 9-4.5" strokeLinejoin="round" />
  </svg>
);

const IconArrowRight = (props) => (
  <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" {...props}>
    <path d="M4 12h15M13 6l6 6-6 6" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
);

function HomePage({ defaultModal = null }) {
  const [activeModal, setActiveModal] = useState(defaultModal);
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const [rememberMe, setRememberMe] = useState(false);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  useEffect(() => {
    setActiveModal(defaultModal);
  }, [defaultModal]);

  const closeModal = () => {
    setActiveModal(null);
    setError("");
    setPassword("");
    setShowPassword(false);
    setRememberMe(false);
  };

  const handleLogin = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);

    try {
      const payload = new FormData();
      payload.append("email", email.trim());
      payload.append("password", password);

      const res = await fetch(`${API_BASE}/login`, { method: "POST", body: payload });
      if (!res.ok) throw new Error("Login failed");
      const data = await res.json();
      setToken(data.access_token, rememberMe);
      closeModal();
      window.location.replace("/");
    } catch (err) {
      setError("Invalid login. Please check email & password.");
    } finally {
      setLoading(false);
    }
  };

  // const headerNavItems = ["Features", "How it works", "Supported banks", "Pricing", "FAQ", "Contact"];

  const trustItems = [
    { title: "Encrypted end to end", text: "Files never leave secure storage", Icon: IconShield },
    { title: "Built for statements", text: "OCR tuned to bank layouts, not plain text", Icon: IconScan },
    { title: "Minutes, not hours", text: "No more re-typing rows by hand", Icon: IconClock },
  ];

  const statementRows = [
    ["01/01/2024", "Payment received", "2,500.00", "-", "2,500.00"],
    ["02/01/2024", "Office supplies", "-", "125.00", "2,375.00"],
    ["03/01/2024", "Client payment", "1,200.00", "-", "3,575.00"],
  ];

  const workSteps = [
    { title: "Upload your statement", text: "Add a bank statement PDF. Scans and digital exports both work.", Icon: IconUpload },
    { title: "Choose your bank", text: "Pick from 25+ supported UK banks so we read the layout correctly.", Icon: IconBank },
    { title: "Get your spreadsheet", text: "We convert it to Excel, with columns matched to your bank's format.", Icon: IconGrid },
    { title: "Check the numbers", text: "Review the spreadsheet and adjust anything that needs a closer look.", Icon: IconEdit },
    { title: "Send back the edits", text: "Upload your corrected file to move on to the next step.", Icon: IconUpload },
    { title: "Build the filter sheet", text: "We flag large transactions, repeats, and direct debits automatically.", Icon: IconFilter },
  ];

  const benefits = [
    { title: "Fast conversion", text: "Statements convert in seconds, not hours of manual entry.", Icon: IconBolt },
    { title: "25+ banks supported", text: "Built for the account formats used across UK high-street and digital banks.", Icon: IconBank },
    { title: "High accuracy OCR", text: "Reads tables the way a person would, not just raw text.", Icon: IconScan },
    { title: "Data stays private", text: "Files are encrypted in transit and never shared with third parties.", Icon: IconLock },
    { title: "Filter sheets included", text: "Large transactions, recurring payments, and direct debits, sorted for you.", Icon: IconFilter },
    { title: "Bulk uploads", text: "Convert a batch of statements in one go.", Icon: IconStack },
  ];

  return (
    <div className="siq">
      <header className="siq-header">
        <div className="siq-header-inner">
          <Link to="/" className="siq-logo-link">
            <span className="siq-logo-mark" aria-hidden="true">S</span>
            <span className="siq-logo-text">StatementIQ</span>
          </Link>

          <nav className="siq-nav" aria-label="Page sections">
            {/* {headerNavItems.map((item) => (
              <span key={item} className="siq-nav-item">
                {item}
              </span>
            ))} */}
          </nav>

          <div className="siq-header-actions">
            <button type="button" className="siq-btn" onClick={() => setActiveModal("login")}>
              Sign in
            </button>
            <button type="button" className="siq-btn siq-btn-primary" onClick={() => setActiveModal("signup")}>
              Get started
            </button>
          </div>
        </div>
      </header>

      <main>
        <section className="siq-hero">
          <div className="siq-hero-copy">
            <h1 className="siq-hero-title">Bank statements, ready for the spreadsheet</h1>

            <p className="siq-hero-text">
              Upload a PDF statement from any of 25+ UK banks and get back a clean
              spreadsheet in minutes. No manual re-typing, no formatting to fix.
            </p>

            <div className="siq-hero-actions">
              <button type="button" className="siq-btn siq-btn-primary" onClick={() => setActiveModal("signup")}>
                Get started free
              </button>
              <button type="button" className="siq-btn" onClick={() => setActiveModal("login")}>
                Sign in
              </button>
            </div>

            <div className="siq-trust-row">
              {trustItems.map(({ title, text, Icon }) => (
                <div className="siq-trust-item" key={title}>
                  <Icon />
                  <span>
                    <strong>{title}</strong>
                    {text}
                  </span>
                </div>
              ))}
            </div>
          </div>

          <div className="siq-hero-visual" aria-hidden="true">
            <div className="siq-doc-flow">
              <span className="siq-doc-chip">Statement.pdf</span>
              <IconArrowRight className="siq-doc-arrow" />
              <span className="siq-doc-chip is-target">Statement.xlsx</span>
            </div>

            <div className="siq-sheet">
              <div className="siq-sheet-head">
                <span className="siq-sheet-head-title">
                  <span className="siq-sheet-head-dot" />
                  Current account, converted
                </span>
              </div>

              <div className="siq-table">
                <div className="siq-table-head">Date</div>
                <div className="siq-table-head">Description</div>
                <div className="siq-table-head">Money in</div>
                <div className="siq-table-head">Money out</div>
                <div className="siq-table-head">Balance</div>

                {statementRows.flatMap((row, rowIndex) =>
                  row.map((cell, cellIndex) => (
                    <div className="siq-table-cell" key={`${rowIndex}-${cellIndex}`}>
                      {cell}
                    </div>
                  ))
                )}
              </div>

              <div className="siq-table-row-fade">
                <span />
                <span />
                <span />
              </div>
            </div>
          </div>
        </section>

        <section className="siq-section" id="how-it-works" aria-labelledby="how-it-works-title">
          <h2 className="siq-section-title" id="how-it-works-title">
            How it works
          </h2>

          <div className="siq-steps">
            {workSteps.map((step, index) => (
              <div className="siq-step" key={step.title}>
                <div className="siq-step-number">{index + 1}.</div>
                <div className="siq-step-body">
                  <h3>{step.title}</h3>
                  <p>{step.text}</p>
                </div>
              </div>
            ))}
          </div>
        </section>

        <section className="siq-section" id="why-statementiq" aria-labelledby="why-statementiq-title">
          <h2 className="siq-section-title" id="why-statementiq-title">
            Why teams use StatementIQ
          </h2>

          <div className="siq-benefits">
            {benefits.map(({ title, text, Icon }) => (
              <article className="siq-benefit" key={title}>
                <Icon />
                <h3>{title}</h3>
                <p>{text}</p>
              </article>
            ))}
          </div>
        </section>
      </main>

      <div className="siq-footer-wrap">
        <AppFooter />
      </div>

      {activeModal && (
        <div className="siq-modal-backdrop" onClick={closeModal}>
          <div className="siq-modal" onClick={(e) => e.stopPropagation()}>
            <button type="button" className="siq-modal-close" onClick={closeModal} aria-label="Close">
              ×
            </button>

            {activeModal === "signup" ? (
              <div className="siq-signup">
                <h2>Register</h2>
                <p>New accounts are set up by our team.</p>
                <p>Send us your name, company, and business email address and we'll get you access.</p>
                <p>
                  <a href="mailto:support@statementiq.co.uk">support@statementiq.co.uk</a>
                </p>
                <p>
                  Already registered?{" "}
                  <button type="button" className="siq-inline-link" onClick={() => setActiveModal("login")}>
                    Sign in
                  </button>
                </p>
              </div>
            ) : (
              <form onSubmit={handleLogin} className="siq-form">
                <h2>Sign in</h2>
                <p>Enter your email and password.</p>

                <div className="siq-field">
                  <label htmlFor="home-login-email">Email</label>
                  <input
                    id="home-login-email"
                    type="email"
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                    placeholder="your@email.com"
                    required
                  />
                </div>

                <div className="siq-field">
                  <label htmlFor="home-login-password">Password</label>
                  <div className="siq-password-row">
                    <input
                      id="home-login-password"
                      type={showPassword ? "text" : "password"}
                      value={password}
                      onChange={(e) => setPassword(e.target.value)}
                      placeholder="Password"
                      required
                    />
                    <button type="button" className="siq-password-toggle" onClick={() => setShowPassword((v) => !v)}>
                      {showPassword ? "Hide" : "Show"}
                    </button>
                  </div>
                </div>

                <label className="siq-remember-row" htmlFor="home-login-remember">
                  <input
                    id="home-login-remember"
                    type="checkbox"
                    checked={rememberMe}
                    onChange={(e) => setRememberMe(e.target.checked)}
                  />
                  <span>Remember me on this device</span>
                </label>

                <button type="submit" className="siq-btn siq-btn-primary siq-btn-block" disabled={loading}>
                  {loading ? "Signing in..." : "Sign in"}
                </button>

                {error && <p className="siq-error">{error}</p>}
              </form>
            )}
          </div>
        </div>
      )}
    </div>
  );
}

export default HomePage;
